"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _HeaderRow = _interopRequireDefault(require("./HeaderRow"));

var _ContentRow = _interopRequireDefault(require("./ContentRow"));

var _DetailRow = _interopRequireDefault(require("./DetailRow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AssembleGridRow = function AssembleGridRow(_ref) {
  var headerIcon = _ref.headerIcon,
      titleItems = _ref.titleItems,
      actions = _ref.actions,
      assemble = _ref.assemble,
      detail = _ref.detail,
      columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      startDatetime = _ref.startDatetime,
      columnRangeType = _ref.columnRangeType;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDetails = _useState2[0],
      setShowDetails = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.HeaderRowContainer, null, /*#__PURE__*/_react["default"].createElement(_HeaderRow["default"], {
    headerIcon: headerIcon,
    titleItems: titleItems,
    actions: actions,
    showDetails: showDetails,
    onSwitch: function onSwitch() {
      return setShowDetails(!showDetails);
    }
  })), /*#__PURE__*/_react["default"].createElement(_styles.ContentRowContainer, null, /*#__PURE__*/_react["default"].createElement(_ContentRow["default"], {
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType,
    assemble: assemble
  }), showDetails && /*#__PURE__*/_react["default"].createElement(_DetailRow["default"], {
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType,
    detail: detail
  })));
};

AssembleGridRow.propTypes = {
  headerIcon: _propTypes["default"].any,
  columnSections: _propTypes["default"].number,
  columnQuantity: _propTypes["default"].number,
  startDatetime: _propTypes["default"].instanceOf(Date),
  columnRangeType: _propTypes["default"].oneOf(['HOUR', 'DAY']),
  titleItems: _propTypes["default"].arrayOf(_propTypes["default"].string),
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].func
  })),
  assemble: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    available: _propTypes["default"].bool,
    begin: _propTypes["default"].instanceOf(Date),
    end: _propTypes["default"].instanceOf(Date),
    data: _propTypes["default"].any,
    status: _propTypes["default"].bool,
    icon: _propTypes["default"].any
  })),
  detail: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      available: _propTypes["default"].bool,
      begin: _propTypes["default"].instanceOf(Date),
      end: _propTypes["default"].instanceOf(Date),
      data: _propTypes["default"].any,
      status: _propTypes["default"].bool,
      icon: _propTypes["default"].any
    }))
  }))
};
AssembleGridRow.defaultProps = {
  headerIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  columnSections: 8,
  columnQuantity: 7,
  startDatetime: new Date(),
  columnRangeType: 'DAY',
  titleItems: [],
  actions: [],
  assemble: [],
  detail: []
};
var _default = AssembleGridRow;
exports["default"] = _default;